<div class="nsc-app-root" [hidden]="!isLoggedIn">
  <!-- Routed Feature -->
  @if (useNSCHeader) {
    <div class="w-100">
      <lib-header headerValue="Myhub" rootUrl="/education" appColor="#742C85"></lib-header>
    </div>
  }

  <div class="d-flex flex-row flex-grow-1">
    <div class="side-nav">
      <!-- Sidebar from ui lib -->
      @if (sidebarConfig) {
        <lib-sidebar-nav [config]="sidebarConfig" style="min-height: 100%;"></lib-sidebar-nav>
      }
    </div>
    <div class="w-100 flex-grow-1">
      <!-- Service Outage Code Start -->
      @if (displayServiceOutage) {
        <div class="w-100 pt-4"
          [ngStyle]="currentUrl === '/' ? {background:'#FFF'} : {background:'#F0F0F0'}">
          <div class="system-alert-container">
            <img src="assets/alert-square.svg" alt="alert-svg">
            <div>
              <h4>Temporary Service Outage</h4>
              <p>{{serviceOutageMessage}}</p>
              <!-- <p>Enrollment Certificate download functionality and Transcript Ordering will be unavailable on Saturday, March 29 between 7:00AM to 11:00AM EST.</p> -->
            </div>
          </div>
        </div>
      }
      <!-- Service Outage Code End -->

      @if (currentUrl === '/' || currentUrl === '/dashboard') {
        <div>
          <app-dashboard></app-dashboard>
        </div>
      }
      @if (currentUrl !== '/' && currentUrl !== '/dashboard') {
        <div>
          <router-outlet></router-outlet>
        </div>
      }

    </div>
    @if (sysError) {
      <div class="nodata-container">
        <app-system-error idx="appRoot"></app-system-error>
      </div>
    }
  </div>

  <!--Footer-->
  <div class="w-100"><lib-footer></lib-footer></div>
</div>

